// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://mzjkvljvledttgrbadbm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im16amt2bGp2bGVkdHRncmJhZGJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM1NjM5MTUsImV4cCI6MjA2OTEzOTkxNX0.1tShimfDDZULt55fzzndD7Mg8ZNe5EiKdO2JYFnhYlE";
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
